import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getIsUngated", "onChange", "onBlur", "className", "error", "field", "value", "isNotUsingTimePoints", "condition"];
// @ts-expect-error untyped
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
// @ts-expect-error untyped
import { getTransferableProps } from './filterInputProps';
import { fromSimpleDateToMoment, fromMomentToSimpleDate
// @ts-expect-error untyped
} from '../../utilities/momentSimpleDateConversion';
import MomentDate from '../propTypes/MomentDate';
import TimezoneToggle from './TimezoneToggle';
import { useState, useEffect } from 'react';
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import EqualTimePoint from '../../filterQueryFormat/operator/EqualTimePoint';
import BeforeTimePoint from '../../filterQueryFormat/operator/BeforeTimePoint';
import AfterTimePoint from '../../filterQueryFormat/operator/AfterTimePoint';
import UpdateDateFilterWithTimezonesNotification from './UpdateDateFilterWithTimezonesNotification';
// @ts-expect-error ts-migrate(2749) FIXME: 'FilterOperatorType' refers to a value, but is bei... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDateInputMoment = props => {
  const {
      getIsUngated,
      onChange,
      onBlur,
      className,
      error,
      field,
      value,
      isNotUsingTimePoints,
      condition
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [useUTC, setUseUTC] = useState(value ? value.isUTC() : field.get('type') === DATE);
  const [showTimezoneToggle, setShowTimezoneToggle] = useState(false);
  const {
    hasTimezones
  } = condition;
  const isDateTimeOperator = field.get('type') === DATE_TIME;
  useEffect(() => {
    if (hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && !hasTimezones && (condition.constructor === EqualTimePoint || condition.constructor === BeforeTimePoint || condition.constructor === AfterTimePoint)) {
      setShowTimezoneToggle(false);
    } else {
      setShowTimezoneToggle(true);
    }
  }, [condition.constructor, getIsUngated, hasTimezones, isDateTimeOperator]);
  const handleChange = evt => {
    if (hasRemoveTimezoneForDates(getIsUngated) && !hasTimezones) {
      onChange(syntheticEvent(fromSimpleDateToMoment(evt.target.value, false)));
    } else {
      onChange(syntheticEvent(fromSimpleDateToMoment(evt.target.value, useUTC)));
    }
  };
  const handleUpdateClick = () => {
    setUseUTC(false);
    if (!value) {
      return;
    }
    setShowTimezoneToggle(false);
    const newValue = I18n.moment.portalTz(value.format('YYYY-MM-DD'));
    onChange(syntheticEvent(newValue), {
      hasClickedUpdate: true
    });
  };
  const handleTimezoneChange = newUseUTC => {
    setUseUTC(newUseUTC);
    if (!value) {
      return;
    }
    const newValue = newUseUTC ? I18n.moment.utc(value.format('YYYY-MM-DD')) : I18n.moment.portalTz(value.format('YYYY-MM-DD'));
    onChange(syntheticEvent(newValue));
  };
  const handleOpenChange = evt => {
    if (!evt.target.value && onBlur) {
      onBlur();
    }
  };
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder,
    disabled,
    onKeyDown,
    onKeyPress,
    onKeyUp,
    readOnly
  } = transferableProps;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIDateInput, {
        className: className,
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        onChange: handleChange,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onOpenChange: handleOpenChange,
        placeholder: placeholder,
        readOnly: readOnly,
        value: fromMomentToSimpleDate(value)
      }), showTimezoneToggle && /*#__PURE__*/_jsx(TimezoneToggle, {
        fieldType: field.get('type'),
        getIsUngated: getIsUngated,
        isNotUsingTimePoints: isNotUsingTimePoints,
        onChange: handleTimezoneChange,
        useUTC: useUTC
      }), showTimezoneToggle && !isNotUsingTimePoints && hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && /*#__PURE__*/_jsx(UpdateDateFilterWithTimezonesNotification, {
        onUpdateClick: handleUpdateClick,
        useUTC: useUTC
      })]
    })
  });
};
FilterOperatorDateInputMoment.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  isNotUsingTimePoints: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: MomentDate
};
export default FilterOperatorDateInputMoment;